export default __webpack_public_path__ + "static/media/embarcacao.57eaf9ed.WEBP";